import { render, staticRenderFns } from "./EnglishStep.vue?vue&type=template&id=e5dd9b52&"
import script from "./EnglishStep.vue?vue&type=script&lang=js&"
export * from "./EnglishStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports